import React, { FC } from 'react';
import TextInput from '../TextInput';
import { SafeAreaView, TextInputProps } from 'react-native';
import styles from './styles';

type SpotifyInputProps = {
  errorMessage?: string | boolean;
  value: string;
  onBlur: Function;
  onChangeText: Function;
};

export type InputProps = SpotifyInputProps & TextInputProps;

export const SpotifyInput: FC<InputProps> = (props) => {
  const { errorMessage, onBlur, onChangeText, value } = props;
  return (
    <SafeAreaView>
      <TextInput
        autoCapitalize="none"
        autoCompleteType="off"
        autoCorrect
        errorMessage={errorMessage}
        imageKey={'spotify'}
        imageStyle={styles.imageStyle}
        keyboardType="default"
        label="Spotify Uri"
        labelHidden
        onBlur={onBlur}
        onChangeText={onChangeText}
        placeholder="Spotify Uri"
        value={value}
        textContentType="none"
      />
    </SafeAreaView>
  );
};

export default SpotifyInput;
